<template>
    <transition name="fade">
        <div
            v-show="($parent.outcome.message && $parent.outcome.status)"
            class="alert"
            :class="($parent.outcome.status === 'success' ? 'alert-success' : 'alert-danger')"
            v-html="$parent.outcome.message"
        >
        </div>
    </transition>
</template>

<style>
    .fade-enter-active,
    .fade-leave-active
    {
        transition: opacity .5s;
    }
    .fade-enter,
    .fade-leave-to
    {
        opacity: 0;
    }
</style>
